/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */
export default {
    //类型
    type: 'text',
    //类别
    class: 'elem',
    //组件名称
    name: '文本',
    //图标
    iconImg: '/image/viewElement/text.png',
    //大屏图标
    bigIconImg: '/image/viewElement/text.png',
    //是否在多维分析展示
    viewType: false,
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 0,
        //最小度量数量
        minDLLength: 0,
        //最大维度数量
        maxWDLength: 0,
        //最大度量数量
        maxDLLength: 0,
        //高
        dp_height: 50,
        //宽
        dp_wight: 220,
        //最小高
        dp_min_height: 20,
        //宽宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: false,
        //是否展示度量配置
        isDlConfig: false,
        //是否展示JSON配置
        isJSONConfig: false,
        //是否展示公共配置
        isComConfig: false,
        //是否展示边框
        isComBorder: true,
    },
    component: () => import('./component/textCom.vue'),
    // 子集展示的配置项
    chilCharts: [
        {
            name: '单行文本',
            //多维分析图标
            ordImg: 'text/icon01.png',
            //大屏图标
            bigImg: 'text/icon01.png',
            //默认配置
            chartParam: {
                textType:'input',
                align: 'center',
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
        {
            name: '多行文本',
            //多维分析图标
            ordImg: 'text/icon02.png',
            //大屏图标
            bigImg: 'text/icon02.png',
            //默认配置
            chartParam: {
                textType:'textarea',
                align: 'left',
            },
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        }
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
    //度量参数
    dlHandle(option) {
        return {}
    },
    //配置参数
    params(option) {
        return {
            textType:'input',
            fontFamily: '宋体',
            fontSize: '20',
            letterSpacing:'0',
            color: '#fff',
            fontWeight: '100',
            align: 'center',
            centent:'',
            backgroundColor: 'rgba(255,255,255,0)'
        }
    },
    //配置组件列表
    configModule:[
        {
            name: '文本配置',
            component: () => import('./config/text_config')
        },],
    //接口
    JSONData: {
        //静态数组
        listDaVal: '',
        //接口参数
        params: {},
        //引用的组件
        jsonPonent: null,
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
    },
    //切换图表之前的回调
    renderBefore(chart, nowChart, dom) {

    },
    //渲染
    rendering(chart, nowChart, dom) {

    }
}
